import script from "./PasswordInputComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordInputComponent.vue?vue&type=script&setup=true&lang=js"

import "./PasswordInputComponent.vue?vue&type=style&index=0&id=3ce0936c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce0936c"]])

export default __exports__